import React from 'react';
import { Link } from 'react-router-dom';
import type { SimpleBlogEntryProps } from './SimpleBlogEntry';

function TeaserBlogEntry({
    imageUrl,
    imageAlt = '',
    date,
    title,
    id,
    category = '',
    linkTo = '/blog-details',    
    onSelect
}: SimpleBlogEntryProps) {
    const isExternal = linkTo.startsWith('http://') || linkTo.startsWith('https://');

    const handleClick = (e: React.MouseEvent) => {
        if (onSelect) {
            e.preventDefault();
            e.stopPropagation();
            onSelect();
        }
    };

    const titleContent = onSelect ? (
        <span>{title}</span>
    ) : isExternal ? (
        <a href={linkTo} target="_blank" rel="noopener noreferrer">{title}</a>
    ) : (
        <Link to={linkTo+'?id='+id}>{title}</Link>
    );

    return (
        <div
            className={`post-item ${onSelect ? 'post-item-selectable' : ''}`}
            onClick={onSelect ? handleClick : undefined}
            role={onSelect ? 'button' : undefined}
            tabIndex={onSelect ? 0 : undefined}
            onKeyDown={onSelect
                ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(); } }
                : undefined
            }
        >
            <img src={imageUrl} alt={imageAlt} className="flex-shrink-0" />
            <div>
                <h4>{titleContent}</h4>
                <time dateTime={date}>{date}</time>
                {category && <span className="tags">{category.split(',').map((item) => <span key={item} className="badge bg-primary me-1">{item}</span>)}</span> }
            </div>
        </div>
    );
}

export default TeaserBlogEntry;
